import React from "react"
import { Form, Input } from "antd"
import { WrappedFormUtils } from "antd/lib/form/Form"
import { Maybe } from "@figurepos/fgr-lib-business-logic/lib/common/types"
import { Pricing } from "../../../../../graphql/types"
import { PriceInput } from "../../../../uiKit/PriceInput/PriceInput"
import { PercentageInput } from "../../../../uiKit/PercentageInput/PercentageInput"
import { CheckboxFormItem, formItemLayoutBalanced } from "../../_components/SettingFormItems"
import SingleChoicePicker from "../../../../common/SingleChoicePicker"

export const MO_DISCOUNT_FORM_FIELDS = ["moDiscountEnabled", "moDiscountName", "moDiscountType", "moDiscountValue"]

type Props = {
    form: WrappedFormUtils
    enabled: boolean
    pricing: Maybe<Pricing>
    onChange: () => void
}

export const MoFirstOrderDiscount = ({ form, enabled, pricing, onChange }: Props) => {
    const initialType = pricing?.absolute != null && pricing.percentage == null ? "absolute" : "percentage"
    const enabledField = CheckboxFormItem(
        { moDiscountEnabled: { value: enabled, indeterminate: false } },
        "moDiscountEnabled",
        "Enable First Order Discount on Mobile Ordering App",
        form,
        null,
        onChange,
        "receipt-setting-form-item",
        "Set up discount (e.g -10%)"
    )
    const typeField = form.getFieldDecorator("moDiscountType", {
        initialValue: initialType,
        valuePropName: "selectedItemId",
        trigger: "onItemSelected",
    })
    const type = form.getFieldValue("moDiscountType") ?? initialType
    const isEnabled = form.getFieldValue("moDiscountEnabled") ?? enabled
    const inputOptions = {
        initialValue: Math.abs(pricing?.percentage ?? pricing?.absolute ?? 0) || null,
        rules: [{ required: true, type: "number" as const, min: 1, message: "Enter a discount greater than zero" }],
    }

    return (
        <>
            {enabledField}
            {isEnabled ? (
                <>
                    <Form.Item
                        className="receipt-setting-form-item"
                        label="Promo Name"
                        style={{ marginLeft: "3rem", marginBottom: 0 }}
                        {...formItemLayoutBalanced}>
                        {form.getFieldDecorator("moDiscountName", {
                            initialValue: pricing?.name ?? "",
                        })(<Input placeholder="First App Order" onChange={onChange} style={{ width: "12rem" }} />)}
                    </Form.Item>
                    <Form.Item
                        className="receipt-setting-form-item"
                        label={type === "percentage" ? "Promo Discount Percentage" : "Promo Discount Amount"}
                        style={{ marginLeft: "3rem", marginBottom: 0 }}
                        {...formItemLayoutBalanced}>
                        <div style={{ display: "flex", justifyContent: "flex-end", gap: "1rem" }}>
                            {form.getFieldDecorator(
                                "moDiscountValue",
                                inputOptions
                            )(
                                type === "percentage" ? (
                                    <PercentageInput onChange={onChange} style={{ width: "8rem" }} />
                                ) : (
                                    <PriceInput onChange={onChange} style={{ width: "8rem" }} />
                                )
                            )}
                            {typeField(
                                <SingleChoicePicker
                                    onItemSelected={() => {
                                        form.setFieldsValue({ moDiscountValue: null })
                                        onChange()
                                    }}
                                    placeHolder="Select Value Type"
                                    style={{ minWidth: "8rem", maxWidth: "8rem" }}
                                    data={[
                                        { id: "percentage", title: "Percentage" },
                                        { id: "absolute", title: "Absolute" },
                                    ]}
                                />
                            )}
                        </div>
                    </Form.Item>
                </>
            ) : null}
        </>
    )
}
